import { useState, useContext } from 'react';
import { CheckCircle } from 'lucide-react';
import AuthContext from '../../../../../../../context/AuthContext';
import { useToast } from '../../../../../../../context/ToastContext';
import ConfirmationModal from '../../../../../../../components/ConfirmationModal';
import auditPlanService from '../../../../../../../services/audit_services/auditPlanService';

export default function CompleteAuditModal({ isOpen, onClose, planId, onSuccess }) {
  const { authTokens } = useContext(AuthContext);
  const { showError, showSuccess } = useToast();
  const [loading, setLoading] = useState(false);

  const handleComplete = async () => {
    setLoading(true);
    
    try {
      const result = await auditPlanService.completeAuditPlan(authTokens.access, planId);
      
      if (result.success) {
        showSuccess('Plan d\'audit terminé avec succès !');
        onSuccess();
        onClose();
      } else {
        showError(result.error || 'Échec de la finalisation du plan d\'audit');
      }
      setLoading(false);
    } catch (error) {
      console.error('Error completing audit plan:', error);
      showError('Erreur lors de la finalisation du plan d\'audit');
      setLoading(false);
    }
  };

  return (
    <ConfirmationModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={handleComplete}
      title="Terminer le plan d'audit"
      message="Êtes-vous sûr de vouloir marquer ce plan d'audit comme terminé ? Cela indique que tous les travaux d'audit ont été achevés."
      confirmText={loading ? 'Finalisation en cours...' : 'Terminer l\'audit'}
      confirmButtonClass="bg-green-600 hover:bg-green-700"
      icon={<CheckCircle className="h-6 w-6 text-green-600" />}
      loading={loading}
    />
  );
}
